export function initSliderVideos() {
    const videos = document.querySelectorAll('video');
    const addSourceToVideo = (element, src) => {
        const source = document.createElement('source');
        source.src = src;
        source.type = 'video/mp4';
        if (!element.firstChild)
            element.appendChild(source);
    };
    const whichSizeVideo = (element) => {
        const windowWidth = window.innerWidth;
        if (windowWidth > 1025)
            addSourceToVideo(element, element.dataset.desktopVid);
        else if (windowWidth > 769)
            addSourceToVideo(element, element.dataset.tabletVid);
        else
            addSourceToVideo(element, element.dataset.mobileVid);
    };
    const videoSize = () => {
        if (videos !== undefined) {
            videos.forEach((element, index) => {
                whichSizeVideo(element);
            });
        }
    };
    videoSize();
}
export function stopVideo(element) {
    const iframe = element.querySelector('iframe');
    const video = element.querySelector('video');
    if (iframe) {
        const iframeSrc = iframe.src;
        iframe.src = iframeSrc;
    }
    if (video) {
        video.pause();
    }
}
